import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
export default function ClientLendingApplicationView() {
    const params = useParams();
    const [lendingApplication, setLendingApplication] = useState({});
    const [documents, setDocuments] = useState([]);
    const [lenders, setLenders] = useState([]);
    const [offers, setOffers] = useState([]);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetUserDocuments = (Id) => {
        axios.get(config.APIACTIVATEURL + config.GETCLIENTDOCUMENTS + "?Id=" + params.lendingApplicationId + "", { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setDocuments(response.data.data);
                }
            });
    };
    const GetLenders = (Id) => {
        axios
            .get(config.APIACTIVATEURL + config.GETAPPLICATIONLENDERBYAPPLICATION + "/" + params.lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLenders(response.data.data.data);
                }
            });
    };
    const GetOffers = (Id) => {
        axios
            .get(config.APIACTIVATEURL + config.GETAPPLICATIONLOANBYAPPLICATION + "/" + params.lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setOffers(response.data.data.data);
                }
            });
    };
    const GetApplication = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETLENDINGAPPLICATION + "/" + params.lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLendingApplication(response.data.data);
                    if (response.data.data !== null) {
                        GetUserDocuments(response.data.data.userId);
                        GetLenders(response.data.data.userId);
                        GetOffers(response.data.data.userId);
                    }
                }
            });
    }
    useEffect(() => {
        GetApplication();
    }, [])
    return (
        <div id="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                    <h5 className="mb-0 ms-2">Application Details</h5>
                </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title mb-3">Contact Information</h5>
                        <div className="row">
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Business Legal Name : {lendingApplication.businessLegalName}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Business DBA(if applicable) : {lendingApplication.businessDBA}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Business Phone : {lendingApplication.businessPhoneNumber}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Mobile Phone : {lendingApplication.businessMobilePhone}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Business Fax : {lendingApplication.businessFax}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Other Phone : {lendingApplication.otherPhoneNumber}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Website : {lendingApplication.website}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Email : {lendingApplication.businessEmail}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Physical Address : {lendingApplication.physicalAddress}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">City : {lendingApplication.physicalAddressCity}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">State : {lendingApplication.physicalAddressState}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Zip : {lendingApplication.physicalAddressZip}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Mailing Address : {lendingApplication.mailingAddress}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">City : {lendingApplication.mailingCity}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">State : {lendingApplication.mailingState}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Zip : {lendingApplication.mailingZip}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title mb-3">Business Information</h5>
                        <div className="row">
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Legal Entity : {lendingApplication.businessLegalName}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Business Start Date : {lendingApplication.businessDBA}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">FederalTaxID : {lendingApplication.federalTaxID}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">HomeBasedBusiness : {lendingApplication.homeBasedBusiness}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Open Judgements / Liens? {lendingApplication.openJudgements}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Open Bankruptcies? : {lendingApplication.openBankruptcies}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">State Of Inc/LLC : {lendingApplication.stateOfLLC}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Business Description : {lendingApplication.businessDescription}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Industry Type (SIC Code) : {lendingApplication.industryType}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Business Rent/Mortgage Information : {lendingApplication.businessRentInformation}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">State : {lendingApplication.physicalAddressState}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Monthly Rent/Lease/Mtg Payment(USD) : {lendingApplication.monthlyRentPayment}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Remaining Term for Rent/Lease: {lendingApplication.remainingRentTerm}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Payment Current(USD)  : {lendingApplication.paymentCurrent}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Landlord/Mortgage Company Contact : {lendingApplication.landlordCompanyContact}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Landlord PhoneNumber : {lendingApplication.landlordPhoneNumber}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title mb-3">Funding Information</h5>
                        <div className="row">
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Amount Requested(USD)  : {lendingApplication.amountRequested}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">When Are Funds Needed : {lendingApplication.fundsNeededIn}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Desired Use of Funding Proceeds : {lendingApplication.desiredFundingUse}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Gross Annual Sales(USD)  : {lendingApplication.grossAnnualSales}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Gross Monthly Sales(USD)  {lendingApplication.grossMonthlySales}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Monthly Credit Card Volume(USD) : {lendingApplication.monthlyCreditCardVolume}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Current Cash Advance?: {lendingApplication.currentCashAdvance}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Cash Advance/Loan Balance(USD)  : {lendingApplication.cashAdvanceLoanBalance}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Current Credit Card Processing Company : {lendingApplication.creditCardCompany}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Account Number : {lendingApplication.accountNumber}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title mb-3">Owner/Principal Information</h5>
                        <div className="row">
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">First Name : {lendingApplication.oFirstName}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">MI : {lendingApplication.omi}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Last Name : {lendingApplication.oLastName}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Title : {lendingApplication.oTitle}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">% Ownership {lendingApplication.oOwnership}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Home Address: {lendingApplication.oHomeAddress}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">City: {lendingApplication.oCity}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">State: {lendingApplication.oState}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Zip : {lendingApplication.oZip}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Home Phone: {lendingApplication.oHomePhone}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Mobile Phone: {lendingApplication.oMobileNumber}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Date of Birth: {lendingApplication.oDateOfBirth}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">SS#: {lendingApplication.ossn}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">FICO Score: {lendingApplication.oFicoScore}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Mother's Maiden Name: {lendingApplication.oMothersMaidenName}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Previous Address: {lendingApplication.oPreviousAddress}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title mb-3">CO-Owner/Principal Information</h5>
                        <div className="row">
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">First Name : {lendingApplication.cFirstName}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">MI : {lendingApplication.cmi}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Last Name : {lendingApplication.cLastName}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Title : {lendingApplication.cTitle}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">% Ownership {lendingApplication.cOwnership}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Home Address: {lendingApplication.cHomeAddress}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">City: {lendingApplication.cCity}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">State: {lendingApplication.cState}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Zip : {lendingApplication.cZip}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Home Phone: {lendingApplication.cHomePhone}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Mobile Phone: {lendingApplication.cMobileNumber}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Date of Birth: {lendingApplication.cDateOfBirth}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">SS#: {lendingApplication.cssn}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">FICO Score: {lendingApplication.cFicoScore}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Mother's Maiden Name: {lendingApplication.cMothersMaidenName}</label>
                            </div>
                            <div className="col-lg-3 mb-3">
                                <label htmlFor="reason" className="form-label">Previous Address: {lendingApplication.cPreviousAddress}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="cardbody">
                        <div className="col-lg-12 mb-3">
                            <h5 className="text-bg-primary p-3">Bank Statements</h5>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-borderless align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col">File Name</th>
                                        <th scope="col">Upload Date</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documents.length > 0 && documents.map(d =>
                                        <tr>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm">
                                                        <div className="avatar-title bg-soft-primary text-primary rounded fs-20">
                                                            <i className="ri-file-zip-fill" />
                                                        </div>
                                                    </div>
                                                    <div className="ms-3 flex-grow-1 me-2">
                                                        <h6 className="fs-4 mb-0">{d.documentName}</h6>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{moment.utc(d.createdDate).local().format("YYYY-MM-DD hh:mm a")}</td>
                                            <td>
                                                <ul className="list-inline hstack gap-2 mb-0">
                                                    <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                        <Link className="edit-item-btn" to={d.imageSrc} target="_blank"><i className="ri-eye-fill align-bottom text-muted" /></Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="cardbody">
                        <div className="col-lg-12 mb-3">
                            <h5 className="text-bg-primary p-3">Matching Funders</h5>
                        </div>
                        <div className="col-lg-12">
                            <div className="table-responsive">
                                <table className="table table-borderless align-middle mb-0">
                                    <thead className="table-light">
                                        <tr className="text-left">
                                            <th scope="col">Company Name</th>
                                            <th scope="col">Contact Name</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Reason</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-left">
                                        {lenders.length > 0 && lenders.map(d =>
                                            <tr>
                                                <td>{d.companyName}</td>
                                                <td>{d.contactName}</td>
                                                <td>{d.email}</td>
                                                <td>{
                                                    d.status === "ELIGIBLE" ? <span className="badge text-bg-warning">NOT YET APPLIED</span> :
                                                        d.status === "APPLY" ? <span className="badge text-bg-primary">APPLIED</span> :
                                                            d.status === "REJECTED" ? <span className="badge text-bg-danger">REJECTED</span> :
                                                                d.status === "APPROVED" ? <span className="badge text-bg-success">APPROVED</span> : d.status}
                                                </td>
                                                <td>{d.reason}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="cardbody">
                        <div className="col-lg-12 mb-3">
                            <h5 className="text-bg-primary p-3">Offers from funders</h5>
                        </div>
                        {offers.length > 0 && offers.map(offer =>
                            <div className="col-4">
                                <div className="card">
                                    <div className="card-header bg-primary text-white d-flex align-items-center">
                                        <h4 className="card-title text-white mb-0 flex-grow-1">{offer.companyName}</h4>
                                    </div>
                                    <div className="card-body">
                                        <ul className="list-group px-0">
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span>Loan Amount :</span>
                                                <span>USD {offer.loanAmount}</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span>Rate :</span>
                                                <span>{offer.rate}</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span>Payback Amount :</span>
                                                <span>USD {offer.paybackAmount}</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span>Payment Amount :</span>
                                                <span>USD {offer.paymentAmount}</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span>Payment Frequency :</span>
                                                <span>{offer.paymentFrequency}</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span>Number of Payments :</span>
                                                <span>{offer.numberOfPayments}</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span>Commission Points :</span>
                                                <span>{offer.commissionPoints}</span>
                                            </li>
                                            <li className="list-group-item d-flex justify-content-between">
                                                <span>Commission :</span>
                                                <span>USD {offer.commission}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}